<template>
  <a
    :class="$style.tournamentLineButton"
    :href="tournamentLineUrl"
    target="_blank"
    rel="noopener noreferrer"
    @click="onClick"
  >
    <ui-icon
      name="bracket"
      :class="[
        $style.tournamentLineButtonICon,
        $style.tournamentLineButtonIconLiga
      ]"
    />
    {{ t('lineUrl') }}
    <ui-icon
      name="external-link"
      :class="[
        $style.tournamentLineButtonICon,
        $style.tournamentLineButtonIconLink
      ]"
    />
  </a>
</template>

<i18n lang="yaml">
ru:
  lineUrl: Линия турнира
</i18n>

<script lang="ts" setup>
import UiIcon from '@/ui-core/components/icon/index.vue'
import { usePickemAnalytics } from '../../composables/use-pickem-analytics'
import type { Tournament } from '../../types'

const props = defineProps<{
  tournament: Tournament
  tournamentLineUrl: string
}>()

const { t } = useI18n()
const { trackTournamentLineClick } = usePickemAnalytics()

const onClick = () => {
  trackTournamentLineClick({
    tournament: props.tournament,
    tournamentUrl: props.tournamentLineUrl
  })
}
</script>

<style lang="scss" module>
.tournamentLineButton {
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  padding: 0.8em 1.2em;
  border-radius: 0.3em;
  border: 1px solid color-get(--root-rgb-control-default-bg);
  background-color: color-get(--root-rgb-control-default-bg);
  color: color-get(--root-rgb-text-1);
  transition: background 0.15s ease;
  @include typo-get(label-m);
  @include hover-focus {
    background-color: color-get(--root-rgb-bg-special-1);
    border: 1px solid color-get(--root-control-accent-default-hover-bg);
  }

  @include down(md) {
    padding: 0.6em 0.9em;
    background-color: transparent;

    @include hover-focus {
      color: color-get(--root-control-accent-default-hover-bg);
      background-color: color-get(--root-rgb-bg-special-1);

      svg {
        color: color-get(--root-control-accent-default-hover-bg);
      }
    }
  }
}

.tournamentLineButtonICon {
  width: 1em;
  height: 1em;
}

.tournamentLineButtonIconLiga {
  color: color-get(--root-rgb-accent-2);

  @include down(md) {
    display: none;
  }
}

.tournamentLineButtonIconLink {
  color: color-get(--root-rgb-text-2);
}
</style>
